import { centerable as e } from "../decorators/centerable.js";
import { uploadable as l } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as o } from "../../constants.js";
import { defineAttrs as a } from "../../utils/typed-attrs.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const i = a({
  type: { default: "audioFile" },
  url: { default: "" }
}), m = e(
  l({
    inline: !1,
    draggable: !0,
    attrs: i,
    group: "block",
    parseDOM: [
      {
        tag: ".intercom-interblocks-audio-file",
        getAttrs(t) {
          const r = t.querySelector("audio");
          return {
            url: (r == null ? void 0 : r.getAttribute("src")) ?? ""
          };
        }
      },
      {
        tag: ".embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-audio audio",
        getAttrs(t) {
          const r = t.querySelector("source");
          return {
            url: (r == null ? void 0 : r.getAttribute("src")) ?? ""
          };
        }
      }
    ],
    toDOM(t) {
      const r = t.attrs;
      return [
        "div",
        {
          class: `${o.blockContainer} ${o.audio}`
        },
        [
          "audio",
          {
            class: "block-audio-file-player",
            controls: "",
            controlsList: "nodownload nofullscreen noremoteplayback noplaybackrate",
            src: r.url,
            style: "width: 100%;"
          }
        ]
      ];
    }
  })
);
export {
  m as audioFileSpec
};
